import React from "react";

export const TournamentEntriesContext = React.createContext(null);
